import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-checkbox-slider',
  templateUrl: './checkbox-slider.component.html',
  styleUrls: ['./checkbox-slider.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CheckboxSliderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
